import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { useAuth } from "../context/auth-context";
import { useNavigate } from "react-router";

export default function AdminPage() {
  const { currentUser, setCurrentUser } = useAuth();
  const history = useNavigate();

  const [isError, setIsError] = useState(false);
  const [userName, setUserName] = useState("");

  function getUserData() {
    fetch(
      `https://othlpps.loanforceinsider.com/api/SignatureUser/pages/${userName}`
    )
      .then((response) => {
        if (response.status === 404) {
          setIsError(true);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.message === "No results found") {
          setIsError(true);
        }

        currentUser.userData = data;
        history("/");

        return data;
      });
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      getUserData();
    }
  };

  useEffect(() => {
    setCurrentUser({
      admin: true,
    });
  }, []);

  return (
    <div>
      <Header />
      <div className="flex justify-center flex-col items-center mt-24">
        <p>signature site unique name ("tporter")</p>
        <input
          className="w-1/6 rounded"
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          onKeyDown={handleKeyDown} // listen for Enter key here
        />
        <button
          className="bg-blue-primary hover:bg-blue-complimentary text-white font-bold py-2 px-4 rounded mt-12"
          onClick={getUserData}
        >
          Log In as User
        </button>
      </div>
    </div>
  );
}
